import { useState, useEffect } from "react";
import { LAYOUT_CONSTANTS } from "../constants/layout.constants";

export function useResponsive() {
  // SSR-safe defaults: assume desktop initially
  const [isMobile, setIsMobile] = useState(false);
  const [windowWidth, setWindowWidth] = useState<number>(
    LAYOUT_CONSTANTS.MOBILE_BREAKPOINT,
  );

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setWindowWidth(width);
      setIsMobile(width < LAYOUT_CONSTANTS.MOBILE_BREAKPOINT);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return { isMobile, windowWidth };
}
